import * as Sentry from '@sentry/browser';

function captureException(exception: unknown, extra?: Record<string, unknown>): string {
  let eventId = '';
  Sentry.withScope((scope) => {
    scope.setTags({
      integration: 'iterable',
      squad: 'BUEN',
    });
    if (extra) {
      scope.setExtras(extra);
    }
    eventId = Sentry.captureException(exception);
  });

  return eventId;
}

export { captureException };
